import store from '../store';

const isAuthenticatedGuardAdminActivities = async (to, from, next) => {


  if (store.getters["auth/getRole"] === 'ROLE_SUPER_ADMIN' || store.getters["auth/getRole"] === 'ROLE_ADMIN' || store.getters["auth/getRole"] === 'ROLE_ACTIVITIES_ADMIN') {
    next();
  } else {
    next({ name: 'Actividades' });
  }
}

export default isAuthenticatedGuardAdminActivities;
